import InputTypes from 'utils/enums/inputTypes';
import { IField } from 'utils/interfaces/IField';

const topic: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do tópico',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    },
    {
        presentation: 'Selecione uma disciplina',
        label: 'Disciplina',
        name: 'subject',
        type: InputTypes.simpleSelect,
        columns: 3
    }
];

export default topic;
